import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { Hero } from '../sections/Hero';
import { LightSections } from '../sections/LightSections';
import { DarkSections } from '../sections/DarkSections';
export function LandingPage() {
  return <div className="min-h-screen bg-light font-sans text-navy selection:bg-techblue/20 selection:text-techblue" data-id="element-52">
      <Navbar data-id="element-53" />
      <main data-id="element-54">
        <Hero data-id="element-55" />
        <LightSections data-id="element-56" />
        <DarkSections data-id="element-57" />
      </main>
      <Footer data-id="element-58" />
    </div>;
}